import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommonService } from '../common/common.service';
import { EncryptionService } from 'src/app/core/authentication/encryption-service';
import { API_ENDPOINTS } from 'src/app/core/http/api-end-points';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(
    public _commonService: CommonService,
    public _router: Router,
    private httpClint: HttpClient,
    private encryptionService: EncryptionService
  ) {}
  public tempArray: any = [];
  getProjectsObservable(body: any, type: string): Observable<any> {
    if (!this.tempArray) {
      return this.tempArray;
    }

    let endPorint =
      type == 'owned'
        ? API_ENDPOINTS.PROJECTS.PROJECT_LIST_OWNED
        : API_ENDPOINTS.PROJECTS.PROJECT_LIST_SHARED;

    return this.httpClint
      .post(environment.workspaceApiUrl + endPorint, body)
      .pipe(
        map((res) => {
          this.tempArray = res;
          return res;
        })
      );
  }

  searchProject(body: any) {
    const url =
      environment.workspaceApiUrl + API_ENDPOINTS.PROJECTS.SEARCH_PROJECT;
    return this._commonService.performPostRequest(url, body);
  }

  getSearchedProjectData(platform: string, data: any) {
    return data.filter((ele: any) => {
      return ele.p_platformType == platform.toLocaleLowerCase();
    });
  }
}
